import { Component, OnInit } from '@angular/core';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { NgxSpinnerService } from 'ngx-spinner';
import { ModalpopService } from '../modalpop.service';
import { UmsService } from '../ums.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';

@Component({
  selector: 'app-student-hold-details',
  templateUrl: './student-hold-details.component.html',
  styleUrls: ['./student-hold-details.component.scss']
})
export class StudentHoldDetailsComponent implements OnInit {
  StudentDataForm!: FormGroup;
  StudentSearchForm!: FormGroup;
  sessionList: any[] = [];
  SessionFilterList: any[] = [];
  sessionId = 0;
  userPermission: any;
  Table = false;
  selectAll = false;
  UpdateBtn = false;
  CoCode = 0;
  CgCode = 0;
  isBranch = false;
  filteredListBranch: any;
  UserCollege: any;
  subcode!: string;
  filteredsubjectList: any[];
  filteredListExam: any[];
  collegeList: any;
  filteredCollegeList: any;
  sessionNo: any;
  closeMessage: string;
  message: string;
  finalPayload: any[] = [];
  HeadList: any;
  examList
  CourseList: any;
  filteredListCourse: any;
  coCode: any;
  subjectList = []
  emid: any;
  dialogRef!: MatDialogRef<any>;
  dialogRef1!: MatDialogRef<any>;
  sub: any;
  IsFile = false;
  IsFileUpload = false;
  passMarks: any;
  maxMarks: any;
  BranchList: any;
  errMsg: any;
  Student: any;
  currentDate!: Date; 
  finalPayloadUpdate: any[] = [];
  savedpayload: any;
  SubMarkList: any;
  IAMarks = 0;
  errMsgInvalid: boolean[] = [];
  updateDisable: boolean | undefined;
  status: any;
  pageSize = 10;
  pageSizeOptions: number[] = [2, 10, 20];
  currentPage = 1;
  totalItems = 0;
  utp: string;
  formativeASSCreate = true
  formativeASSUpdate = true
  CoName: any;
  CgName: any;
  BranchName: any;
  displayedColumns: string[] = [];
  reportCollegeList: any[] = [];
  filteredReportCollegeList: any[] = [];
  selectedReportColleges: string[] = [];
  commaSeparatedReportColleges: string = '';
  dataSource = new MatTableDataSource<any>();
  private _updatingReportFromMarking = false;
  selectedExamId!: number;
  columns = [
    { field: 'RgNo', header: 'Prn No' },
    { field: 'RgName', header: 'Student Name' },
    { field: 'StrName', header: 'Branch Name' },
    { field: 'Release', header: 'Release' },
  ];


  constructor(private spinner: NgxSpinnerService,
    public umsService: UmsService,
    private fb: FormBuilder,
    private modalPopupService: ModalpopService,
  ) { }

  ngOnInit(): void {
    const userPermissionJson = sessionStorage.getItem("userPermission");
    this.userPermission = userPermissionJson ? JSON.parse(userPermissionJson) : null;
    this.sessionId = 0;
    this.CoCode = 0;
    this.CgCode = 0;

    this.StudentDataForm = this.fb.group({
      college: new FormControl('', Validators.required),
      course: new FormControl('', Validators.required),
      SessionId: new FormControl('', Validators.required),
      EmId: new FormControl('', Validators.required),
      SubCode: new FormControl(''),
      EsId: new FormControl(''),
      Branch: new FormControl(''),

    });
    this.StudentSearchForm = this.fb.group({
      RegNo: new FormControl('', Validators.required),
      studentName: new FormControl('', Validators.required)
    });
    this.utp = sessionStorage.getItem('usertypeee');
    if (this.utp !== 'Super Admin') {
      this.userPermission.forEach((element:any) => {
        if (element.PageName == 'Student WithHeld Release' && element.PCreate == false) {
          this.formativeASSCreate = false;
        }
        if (element.PageName == 'Student WithHeld Release' && element.PUpdate == false) {
          this.formativeASSUpdate = false;
        }
      });
    }
    this.fetchSession();
    // this.fetchStatus();
    this.currentDate = new Date();

    this.StudentDataForm.get('college').valueChanges.subscribe((newCollege: string) => {
      if (this._updatingReportFromMarking) return;

      if (newCollege && this.reportCollegeList.some(c => c.CgCode === newCollege)) {
        this.selectedReportColleges = [newCollege];
        this.commaSeparatedReportColleges = newCollege;
      } else {
        this.selectedReportColleges = [];
        this.commaSeparatedReportColleges = '';
      }
    });
  }

  fetchSession() {
    this.spinner.show();
    const payload: { [key: string]: any } = {};
    this.filteredCollegeList = [];
    this.filteredListExam = [];
    this.filteredListBranch = [];
    this.filteredsubjectList = [];
    this.HeadList = [];
    payload['SnDefault'] = '';
    payload['SnNo'] = '';
    this.umsService.getSession(payload).subscribe(res => {
      this.spinner.hide();
      this.sessionList = [];
      if (res.status) {
        res.data.forEach((element:any) => {
          if (element.SnStatus == 'O') {
            this.sessionList.push(element);
          }
        });
        this.SessionFilterList = this.sessionList.slice();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.sessionList = [];
    })
  }

   getStudentHoldData(examId: number, prnNo?: number,showAlert: boolean = true) {
    this.spinner.show();
    this.selectedExamId = examId;
    
    const payload = {
      examId: examId,
      prnNo: prnNo
    };
    this.umsService.getStudentsHoldData(payload).subscribe(res => {
      this.spinner.hide();

      if (res.data && res.data.length > 0) {
        this.displayedColumns = this.columns.map(col => col.field);

        this.dataSource.data = res.data[0].map((item: any) => ({
          ...item,
          selected: false
        }));

      } else {

        this.displayedColumns = [];
        this.dataSource.data = [];
        this.spinner.hide();
         if (showAlert) {
        let data: any = {}
        data['message'] = res?.message
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
         }
      }
    },
      (err) => {
        this.displayedColumns = [];
        this.dataSource.data = [];
        this.spinner.hide();
        let data: any = {}
        data['message'] = err.error?.message || err.message;
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
    )
  }

  saveInactiveData() {
    const confirmDialog = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, {
      message: `Are You Sure You want to Realease the Selected Students?`,
      title: 'Confirm Save',
      icon: 'fa fa-question'
    });

    confirmDialog.afterClosed().subscribe(confirmed => {
      if (confirmed !== 'yes') return;
      const userId = this.userPermission[0].UserId

      let payload = {
        UserId: userId,
        Data: this.dataSource.data
          .filter(row => row.selected)
          .map(row => ({
            RgNo: row.RgNo
          }))
      };

      this.umsService.updateInactive(payload).subscribe(
        (res) => {

          this.getStudentHoldData(this.selectedExamId, undefined, false)
          this.spinner.hide()
          let data: any = {}
          data['message'] = res.message;
          data['title'] = res.title;
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
        },
        (err) => {
          console.log("ERRRR", err)
        }
      )
    });
  }

  cancelSelection() {
    this.dataSource.data.forEach(row => { row.selected = false })
  }

  selectAllData(isChecked: boolean) {

    this.dataSource.data.forEach(row => {
      row.selected = isChecked;
    });

  }

  searchByPrn() {

    const prnNo = this.StudentSearchForm.get('RegNo')?.value;
    this.getStudentHoldData(this.selectedExamId, prnNo, true)
  }

  getCollege(item) {
    this.getExamList(item);
    this.spinner.show();
    if (this.userPermission[0].CgUi == 'C') {
      this.UserCollege = this.userPermission[0].CgId;
    }
    else {
      this.UserCollege = ''
    }
    this.IsFile = false;
    this.Table = false;
    this.subcode = '';
    this.filteredsubjectList = [];
    this.filteredListExam = [];
    const payload = {};
    payload['CoCode'] = item.CoCode
    this.umsService.fetchstucourseClgMap(payload).subscribe(res => {
      this.spinner.hide();
      this.collegeList = res.data;
      this.filteredCollegeList = this.collegeList.slice();
      this.reportCollegeList = this.collegeList.slice();
      this.filteredReportCollegeList = this.reportCollegeList.slice();
      const currentMarkingCollege = this.StudentDataForm.get('college').value;
      if (currentMarkingCollege && this.reportCollegeList.some(c => c.CgCode === currentMarkingCollege)) {
        this._updatingReportFromMarking = true;
        this.selectedReportColleges = [currentMarkingCollege];
        this.commaSeparatedReportColleges = currentMarkingCollege;
        this._updatingReportFromMarking = false;
      } else {
        this.selectedReportColleges = [];
        this.commaSeparatedReportColleges = '';
      }

    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.collegeList = [];
      this.reportCollegeList = [];
      this.filteredReportCollegeList = [];
    })
  }

  getCourse(data) {
    this.CgName = data.CgName
    this.spinner.show();
    this.CgCode = data.CgCode
    this.sessionNo = data.SnNo
    this.closeMessage = '';
    this.message = ''
    this.finalPayload = []
    let payload2 = this.StudentDataForm.value
    this.Table = false
    this.isBranch = false;
    this.IsFile = false;
    this.filteredListExam = [];
    this.filteredListBranch = [];
    this.filteredsubjectList = [];
    this.HeadList = [];
    this.examList = []
    const payload = {};
    payload['SessionId'] = payload2.SessionId;
    this.umsService.getCourse(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.spinner.hide();
        this.CourseList = res.data;
        this.filteredListCourse = this.CourseList.slice();
      }
      else {
        this.spinner.hide();
        this.CourseList = [];
        this.filteredListCourse = [];
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.CourseList = [];
    })
  }

  getExamList(item) {
    this.spinner.show();
    this.closeMessage = ''
    this.message = ''
    this.finalPayload = []
    this.IsFile = false;
    this.Table = false;
    this.filteredsubjectList = [];
    this.examList = []
    this.isBranch = false;
    const payload = {};
    payload['EmCoCode'] = item.CoCode;
    this.filteredsubjectList = [];
    this.examList = []
    this.umsService.getExam(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.examList = res.data;
        this.filteredListExam = this.examList.slice();
      }
      else {
        this.spinner.hide();
        let data = {}
        data['message'] = res.message
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Alert'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.ngOnInit();

    });
  }

 

  fetchBranch(id) {
    this.spinner.show();
    const payload = {};
    this.filteredsubjectList = [];
    this.subjectList = [];
    this.HeadList = [];
    payload['EmId'] = id;
    this.umsService.getExamStream(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.BranchList = res.data;
        this.filteredListBranch = this.BranchList.slice();
      }
    });
  }

}
